module.exports = __webpack_public_path__ + "images/background/image_thumbnail/1-on-ee6c7457ad42677bd2eb931456a74c33.jpg";